import React, { useState } from 'react';
import './Navbar.css';

const NavBar: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	return (
		<nav className="nav-bar">
			<button
				className="hamburger"
				onClick={toggleMenu}
				aria-label="Toggle navigation menu"
				aria-expanded={isMenuOpen}>
				☰
			</button>

			<ul className={isMenuOpen ? 'active' : ''}>
				<li>
					<a href="/">Home</a>
				</li>
				<li>
					<a href="/shows">Shows</a>
				</li>
				<li>
					<a href="/biography">Biography</a>
				</li>
			</ul>
		</nav>
	);
};

export default NavBar;
